import { Page, type DispatchedAction } from '@eo/shared';

import { timeTrackingController } from './controller';
import { TimeTrackingBody } from './TimeTrackingBody';
import type { TimeTrackingState } from './types';

export default function TimeTrackingPage() {
  return (
    <Page<TimeTrackingState> controller={timeTrackingController as never}>
      {({ data, actions }) => (
        <TimeTrackingBody
          data={data}
          onLogEntry={(payload) => actions.logEntry(payload) as Promise<DispatchedAction>}
          onDismiss={(payload) => actions.dismiss(payload) as Promise<DispatchedAction>}
          onUpdateEntry={(payload) => actions.updateEntry(payload) as Promise<DispatchedAction>}
          onDeleteEntry={(payload) => actions.deleteEntry(payload) as Promise<DispatchedAction>}
          onSetTaskType={(payload) => actions.setTaskType(payload) as Promise<DispatchedAction>}
          onQueryOptions={(payload) => void actions.queryOptions(payload)}
          onAnalyse={(payload) => actions.analyseDay(payload) as Promise<DispatchedAction>}
          onLoadAnalysedRange={(payload) => void actions.loadAnalysedRange(payload)}
        />
      )}
    </Page>
  );
}
